import { useState } from 'react';
import { API } from '../../../../api/api';
import { URLS } from '../../../../api/urls';
import { Modal } from '../../../../components/Modal/Modal';
import { ALERT_TEXT } from '../../../../constants/content';
import { useAlert } from '../../../../context/Alert.context';

import { BannerForm } from './BannerForm';
import { BannersDTO } from '../../types';

interface CreatePageModalProps {
  open: boolean;
  onClose: () => void;
  banner: BannersDTO;
  updateBannerAfterEdit: (data: BannersDTO) => void;
}

export const EditModal = ({
                            open,
                            onClose,
                            banner,
                            updateBannerAfterEdit,
                          }: CreatePageModalProps) => {
  const [loading, setLoading] = useState(false);
  const { showAlert } = useAlert();

  const edit = ( { page, file}: { page: BannersDTO; file: File | null }) => {
    setLoading(true);
    const formData = new FormData();
    formData.append('dto', JSON.stringify(page));
    if (file) {
      formData.append('image', file);
    }
    API.put(`${URLS.BANNERS}/${banner.id}`, formData)
      .then(({ data }) => {
        updateBannerAfterEdit(data);
        onClose();
        showAlert({
          message: ALERT_TEXT.BANNER_EDIT_SUCCESS,
          severity: 'success',
        });
      })
      .catch((e) => showAlert({ message: e.message, severity: 'error' }))
      .finally(() => setLoading(false));
  };

  return (
    <Modal shouldPreventModal title="Edit banner" open={open} onClose={onClose}>
      <BannerForm
        isEdit
        loading={loading}
        onSubmit={edit}
        onCancel={onClose}
        defaultValue={banner}
      />
    </Modal>
  );
};
